/**
 * @generated SignedSource<<fce8064e7d5212d766b9c7985709dd7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductizedServicePriceInterval = "DAY" | "HOUR" | "MONTH" | "WEEK" | "%future added value";
export type ProductizedServicePriceType = "CONTACT_FOR_PRICING" | "FIXED_PRICE" | "RATE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceCardPrice_price$data = {
  readonly amount: number | null;
  readonly interval: ProductizedServicePriceInterval | null;
  readonly timeline: string | null;
  readonly type: ProductizedServicePriceType;
  readonly " $fragmentType": "ProductizedServiceCardPrice_price";
};
export type ProductizedServiceCardPrice_price$key = {
  readonly " $data"?: ProductizedServiceCardPrice_price$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceCardPrice_price">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceCardPrice_price",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "interval",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "ProductizedServicePrice",
  "abstractKey": null
};

(node as any).hash = "e346b7afe5ae6edb0a5a1a19368c41f2";

export default node;
